import { connect } from 'react-redux';
import { history } from '../store';

import UserEditForm from '../components/UserEditForm';
import * as actions from '../actions';
import * as selectors from '../selectors';

const mapStateToProps = state => {
    const struct = {
        user: selectors.getUser(state),
        saveUserFailed: selectors.saveUserFailed(state),
        savingUser: selectors.isSavingUser(state),
        saveUserErrors: selectors.saveUserErrors(state),
        savedUser: selectors.savedUser(state),
        isLoadingUser: selectors.isLoadingUser(state),
        loadUserFailed: selectors.loadUserFailed(state),
    };
    if (struct.user._key) {
        struct.initialValues = struct.user;
    }
    return struct;
};

const mapDispatchToProps = dispatch => {
    return {
        onLoadUser: () => dispatch(actions.fetchUser()),
        onSubmit: data => dispatch(actions.saveUser(data)),
        onEditInstitution: key => history.push(`/edit/${key}`),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEditForm);



/** WEBPACK FOOTER **
 ** ./src/containers/UserEditFormContainer.js
 **/